export default __webpack_public_path__ + "static/media/3334 spice rack A side.16978082.png";